import {
  SimpleForm,
  CreateProps,
  FormDataConsumer,
  ReferenceInput,
  AutocompleteInput,
  required,
  useDataProvider,
  useRedirect,
  useNotify,
  TextInput,
} from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CreateWrapper from "../../components/CreateWrapper";
import moment from "moment/moment";
import WaveInput from "./components/WaveInput";
import RouteInput from "./components/RouteInput";
import AdhocOperatorTarget from "./components/AdhocOperatorTarget";
import CustomDateRangeInput from "../../components/CustomDateRangeInput";
import SaveButton from "./components/SaveButton";

const AdhocOperatorCreate = (props: CreateProps) => {
  const provider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();

  const breadcrumb = [
    { title: "Adhoc Operators", link: "/adhocOperators" },
    { title: "Create", link: "/adhocOperators/create" },
  ];

  return (
    <CreateWrapper
      breadcrumb={breadcrumb}
      headerTitle="New Adhoc Operator"
      isHaveSchoolFilter
      {...props}
    >
      <SimpleForm toolbar={<SaveButton/>}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Route Plan</Typography>
          </Grid>
          <Grid item md={4} xs={12}>
            <WaveInput />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6">Route </Typography>
          </Grid>
          <Grid item md={4} xs={12}>
            <RouteInput />
          </Grid>
          <Grid item md={8} xs={12}></Grid>

          <Grid item xs={12}>
            <Typography variant="h6">Replacement Date </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <CustomDateRangeInput
              fromLabel="Replacement From Date *"
              toLabel="Replacement To Date *"
              toSource="toDate"
              fromSource="fromDate"
              parentStartDate={moment().add(1, "day").format("Y-MM-DD")}
              gridItemWidth={6}
              isWeekdays
            />
          </Grid>
          <Grid item xs={12} md={8}></Grid>

          <Grid item md={4} xs={12}>
            <AdhocOperatorTarget />
          </Grid>
          <Grid item md={8} xs={12}></Grid>

          <FormDataConsumer>
            {({ formData }) => {
              const showDriver =
                formData.target === "driver" || formData.target === "both";
              const showBusAssistant =
                formData.target === "busAssistant" ||
                formData.target === "both";

              return (
                <>
                  {showDriver && (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="h6">Driver</Typography>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <ReferenceInput
                          reference="drivers"
                          source="driverId"
                          validate={required()}
                          filterToQuery={(searchText) => {
                            if (searchText !== "")
                              return { search: searchText };
                          }}
                        >
                          <AutocompleteInput
                            optionText={(choice: any) =>
                              `${choice?.fullName} (${choice?.contactNumber})`
                            }
                          />
                        </ReferenceInput>
                      </Grid>
                    </>
                  )}

                  {showBusAssistant && (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="h6">Bus Assistant</Typography>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <ReferenceInput
                          reference="busAssistants"
                          source="busAssistantId"
                          validate={required()}
                          filterToQuery={(searchText) => {
                            if (searchText !== "")
                              return { search: searchText };
                          }}
                        >
                          <AutocompleteInput
                            optionText={(choice: any) =>
                              `${choice?.fullName} (${choice?.contactNumber})`
                            }
                          />
                        </ReferenceInput>
                      </Grid>
                    </>
                  )}

                  {(showDriver || showBusAssistant) && (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="h6">Subcontractor</Typography>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <ReferenceInput
                          reference="subcontractors"
                          source="subcontractorId"
                          validate={required()}
                          filterToQuery={(searchText) => {
                            if (searchText !== "")
                              return { search: searchText };
                          }}
                        >
                          <AutocompleteInput
                            optionText={(choice: any) =>
                              `${choice?.name} (${choice?.subcontractorIdentifier ?? "N/A"})`
                            }
                          />
                        </ReferenceInput>
                      </Grid>
                    </>
                  )}
                </>
              );
            }}
          </FormDataConsumer>

          <Grid item xs={12}></Grid>
          <Grid item xs={12} md={4}>
            <TextInput
              label="Remark"
              source="remark"
              multiline
              rows={3}
              validate={required()}
            />
          </Grid>
        </SanitizedGrid>
      </SimpleForm>
    </CreateWrapper>
  );
};

export default AdhocOperatorCreate;

export const transform = (data: any) => {
  if (data.target === "driver") {
    data.busAssistantId = null;
  } else if (data.target === "busAssistant") {
    data.driverId = null;
  }
  return data;
};
